import React from 'react';
import { PropTypes } from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useTrackingPage } from 'pages/Tracking/Tracking.hooks';
import LoadsSummaryInline from 'refactored/features/order/loads/displays/LoadsSummaryInline';
import { IS_TENANT } from 'tenant/utils';
import CustomReferencesTable from 'refactored/features/order/references/CustomReferencesTable';

const Header = ({ className }) => {
  const { t } = useTranslation('Tracking');
  const { data } = useTrackingPage();
  if (!data) {
    return null;
  }
  const { id: orderId } = data;
  return (
    <div className={className} data-testid="header">
      <div className="reference">
        <span className="reference__label">{t('reference')}</span>
        <span className="reference__shipment-id">{`S${orderId}`}</span>
      </div>
      {!IS_TENANT && (
        <div className="pallets">
          <LoadsSummaryInline loads={data.loads || []} />
        </div>
      )}
      {IS_TENANT && <CustomReferencesTable data={data} />}
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
};

Header.defaultProps = {
  className: '',
};

export default Header;
